import { render } from "./PatientRegistrationPageMobile.vue?vue&type=template&id=fb0f1146&scoped=true"
import script from "./PatientRegistrationPageMobile.vue?vue&type=script&lang=js"
export * from "./PatientRegistrationPageMobile.vue?vue&type=script&lang=js"

import "./PatientRegistrationPageMobile.vue?vue&type=style&index=0&id=fb0f1146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0f1146"]])

export default __exports__